import * as yup from 'yup';
import { QuoteBlock } from '@web/components';
import { nullableImageFromCMSSchema, richTextFromCMSSchema } from '../schemas';

export const component = QuoteBlock;

export const schema = yup
  .object({
    name: yup.string().required(),
    title: yup.string(),
    image: nullableImageFromCMSSchema,
    body: richTextFromCMSSchema.required(),
    backgroundColor: yup.string(),
  })
  .transform(value => ({
    name: value.name,
    title: value.title,
    image: value.image,
    body: value.body,
    backgroundColor: value.background_color || null,
  }));
